import React, { useState, useEffect, useContext } from "react";
import "popper.js";
import "bootstrap/dist/js/bootstrap";
import { Link, useHistory } from "react-router-dom";
// Componentes
import Foto from "../element/Foto";
import HeaderMenu from "../element/HeaderMenu";
import Menu from "./Menu";
import SkeletonCard from "../element/Skeleton";
// Contexto
import dataContext from "../context/User";
// Helper
import GetFetch from "../helper/GetFetch";
import loadMenu from "../js/main";
import Footer from "./Footer";

const Cum = () => {
  const history = useHistory();

  const dataUser = useContext(dataContext);
  let datos = localStorage.getItem("dataUser");

  const [cum, setCum] = useState(0);
  const [solvencia, setSolvencia] = useState();
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    if (datos) {
      let cred = JSON.parse(datos);
      dataUser.token = cred.token;
      dataUser.nombre = cred.nombre;
      dataUser.carnet = cred.carnet;
      dataUser.perfil = cred.perfil;
      dataUser.carrera = cred.carrera;
  
      let cumAlumno = GetFetch.cum(cred.carnet, cred.token);
      console.log(cumAlumno);
      cumAlumno.then((dataCum) => {
        setCum(dataCum[0].cum.toFixed(1))
        if(localStorage.getItem('solvencia')){
          setSolvencia('INSOLVENTE')
          setTimeout(() => {
            localStorage.removeItem('solvencia')
          }, 5000);
        }
        setCargando(false);
      }).catch(() => setCargando(false));
    } else {
      history.push("/");
    }
    loadMenu();
  }, [datos, dataUser, history]);

  return (
    // <div>

    <div className="wrapper d-flex align-items-stretch">
      <nav id="sidebar">
        <div className="custom-menu">
          <button
            type="button"
            id="sidebarCollapse"
            className="btn btn-primary"
          >
            <i className="fa fa-bars"></i>
            <span className="sr-only">Toggle Menu</span>
          </button>
        </div>
        <div className="p-4">
          <Foto foto={dataUser.carnet} alt="Foto alumno" tamanio="rounded" />

          <HeaderMenu
            carnet={dataUser.carnet}
            nombre={dataUser.nombre}
            perfil={dataUser.perfil}
            carrera={dataUser.carrera}
            posicion="text-center"
          />

          <Menu />

          <Footer />
        </div>
      </nav>

      <div id="content" className="p-4 p-md-5 pt-5">
        <h2 className="mb-4">CUM</h2>

        {cargando ? (
          <SkeletonCard rows={2} />
        ) : solvencia ? (
          <div className="alert alert-danger" role="alert">
            <i className="fa fa-exclamation-circle mr-2" aria-hidden="true"></i>
            <b>Insolvente.</b> Regulariza tus pagos para consultar tu CUM.
          </div>
        ) : (
          <div className="esen-stat-grid">
            <div className="esen-stat esen-stat--hero">
              <div>
                <div className="esen-stat-value">{cum}</div>
                <div className="esen-stat-label">Coeficiente de Unidades de Mérito acumulado</div>
              </div>
            </div>
          </div>
        )}

        <hr className="my-4" />

        <Link className="btn btn-primary btn-block" to="/home">
          <span className="fa fa-cubes mr-2" aria-hidden="true"></span>Horario de clases
        </Link>

        <Link className="btn btn-outline-primary btn-block" to="/horassociales">
          <span className="fa fa-hourglass-half mr-2" aria-hidden="true"></span>Horas sociales
        </Link>

        <Link className="btn btn-outline-primary btn-block" to="/notas">
          <span className="fa fa-sticky-note mr-2" aria-hidden="true"></span>Notas
        </Link>
      </div>
    </div>
  );
};

export default Cum;
